// extracted by mini-css-extract-plugin
export default {"container":"xzc6ry","title":"Tmu7lT","logos":"qZDI08","marquee":"gRibhL"};